import Slider from "react-slick";
import React, {useEffect} from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { css } from "@emotion/react";
import {useIsMobile} from "../../../hooks/useIsMobile";
import {useNavigate, Link} from "react-router-dom";
import GetColor from "../../controls/GetColor";

interface Carousel {
    imageData: Array<ImageDataType>;
}
interface ImageDataType {
    id: number;
    title: string;
    phrase : string;
    author: string;
    profile: string;
    src: string;
    alt: string;
    backgroundColor: string;
}

function PrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <img
                src={`${process.env.PUBLIC_URL}/prev.svg`}
                style={{maxWidth: 'none',  width: "50px" , height: "auto" }}
            />
        </div>
    );
}

function NextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <img
                src={`${process.env.PUBLIC_URL}/next.svg`}
                style={{maxWidth: 'none',  width: "50px" , height: "auto" }}
            />
        </div>
    );
}




const Carousel = ({ imageData }: Carousel) => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();


        // imageData 처리 함수
        const truncatePhrases = (phrase: string) => {
            return phrase.length > 50 ? `${phrase.substring(0, 50)}...` : phrase;
        };



    const handleBookDetail = (bookId : number) => {
        navigate(`/book/bookdetails/${bookId}`);
    };


    const settings = {
        customPaging: function (i: number) {
            return <div css={dotCss}></div>;
        },
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,

    }


    return (
        <div css={carouselCss}>
            <Slider {...settings} arrows={true}>
                {imageData.map((v, i: number) => (
                    <div css={liCss} key={i}  >

                            {isMobile ?

                                <>
                                    <div className="flex flex-col justify-center p-10" style={{ backgroundColor: v.backgroundColor }}>

                                        <div className="flex flex-col gap-3">

                                            <div className="flex flex-col gap-6">
                                                <span className="font-namsan-EB text-[12px] text-black font-semibold">{v.title}</span>

                                                <span className="font-namsan text-base text-black font-medium">
          <span className="text-[22px]">“</span>
                                                    {truncatePhrases(v.phrase)}
        </span>
                                            </div>

                                            {/* 책 표지와 프로필을 가로로 정렬하는 컨테이너 */}
                                            <div className="flex flex-row gap-2 items-end w-full">

                                                {/* 책 표지 */}
                                                <Link to={`/book/bookdetails/${v.id}`} className="cursor-pointer shadow-book w-[173px] h-[253px] block">
                                                    <img
                                                        src={v.src ? `data:image/png;base64,${v.src}` : "/img/book_4.jpg"}
                                                        alt={v.alt}
                                                        style={{ width: "100%", height: "100%" }}
                                                        className="object-cover rounded-lg"
                                                    />
                                                </Link>

                                                {/* 프로필 및 작가명 */}
                                                <div className="flex flex-col ml-4">
                                                    <img
                                                        src={v.profile ? `data:image/png;base64,${v.profile}` : "/img/profile_sam.jpg"}
                                                        alt="작가 프로필"
                                                        style={{ width: "39px", height: "39px", borderRadius: "50%" }}
                                                        className="object-cover"
                                                    />
                                                    <div className={"flex flex-row"}>
                                                        <span className="text-black text-sm font-namsan font-extrabold mt-1">{`${v.author}`}
                                                        <span className="text-black text-[12px] font-namsan font-medium ml-1">작가</span></span>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </>


                                :


                                <>

                                <div className="background" style={{backgroundColor: v.backgroundColor}}>
                                    <div className="carouselWrap">


                                        <div className="carouselText">
                                            <div className="titleWrap">
                                                <p className="title">{v.title}</p>
                                                <p className="pharse">
                                                    <span className="text-[30px]">“</span>
                                                    {truncatePhrases(v.phrase)}
                                                </p>
                                            </div>

                                            <div className="authorWrap">
                                                <div className="w-[58px] h-[58px] rounded-full">
                                                    <img
                                                        className="w-full h-full rounded-full object-cover"
                                                        src={v.profile ? `data:image/png;base64,${v.profile}` : "/img/profile_sam.jpg"}
                                                        alt="작가 프로필"
                                                    />
                                                </div>
                                                <span className="text-black text-[20px] font-namsan font-extrabold">
      {v.author}
                                                    <span className="ml-[4px] text-black text-sm font-namsan font-medium">작가</span>
    </span>
                                            </div>
                                        </div>


                                        <Link
                                            to={`/book/bookdetails/${v.id}`}
                                            className="w-[236px] h-[348px] rounded-10 cursor-pointer overflow-hidden block"
                                            style={{boxShadow: "8px 8px 20px rgba(0, 0, 0, 0.3)"}}
                                        >
                                            <img
                                                src={v.src ? `data:image/png;base64,${v.src}` : "/img/book_4.jpg"}
                                                alt={v.alt}
                                                className="w-full h-full object-cover"
                                            />
                                        </Link>



                                    </div>
                                </div>


                                </>


                                }


                                </div>
                                ))}
                    </Slider>
                    </div>
    );
};

export default Carousel;

const liCss = css`
    position: relative;
    width: 100%;
    display: flex;
    height: 400px;
    justify-content: center;


    .background {
        position: relative;
        width: 100%;
        display: flex;
        height: 400px;
        justify-content: center;
    }
    
    @media (max-width: 640px) {
        height: 460px;
        flex-direction: column;
        
        .background {
            position: relative;
            width: 100%;
            display: flex;
            height: 460px;
            /*justify-content: center;*/
        }
        
        
    }
    
`;




const carouselCss = css`
   /* max-width: 1920px;*/
    justify-content: center;
    width: 100%;
    margin: auto;

   
    .carouselWrap {
        display: flex;
        width: 996px;
        padding : 26px 32px;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        
    }


    .carouselText {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 396px;
        position: relative; /* 작가 위치 기준 */
        min-height: 300px;
    }

    .authorWrap {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        gap: 4px; /* 작가 이름과 '작가' 텍스트 사이 */
        padding-top: 10px;
    }

    .authorFixed {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        gap: 12px;
    }


    .titleWrap{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 26px;
        align-self: stretch;
    }
    
    .title {
        color: #000;
        font-family: SeoulNamsanM;
        font-size: 18px;
        font-style: lignt;
        font-weight: 600;
        line-height: normal;
    }
    
    .pharse {
        color: #000;
        font-family: SeoulNamsanM;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
    }
    .author{
        color: #000;
        text-align: right;
        font-family: SeoulNamsanM;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    
    .slick-dots {
        width: 120px;
        height: 4px;
        border-radius: 10px;
        background-color: #fff;
        position: absolute;
        left: 50%;
        bottom: 23px;
        transform: translateX(-50%);

        li {
            margin: 0;
            width: 30px;
            height: 5px;
            position: relative;
            top: -10px;
            border-radius: 10px;
        }

        .slick-active {
            background-color: #19cf7a;
        }
    }
    
    .slick-list {
        border-radius: 10px;
        margin: 0 auto;
    }
    /* .slick-slide img {
        border-radius: 10px;
    } */
    .slick-arrow.slick-prev {
        &::before {
            content: "";
        }
        z-index: 9;
        top: 180px;
        position: absolute;
        width: 50px;
        height: 50px;
        left: 2px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }
    .slick-arrow.slick-next {
        &::before {
            content: "";
        }
        z-index: 9;
        top: 180px;
        right: 2px;
        position: absolute;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s ease;
        
    }


    @media (max-width: 640px) {
        .carouselWrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px;
        }

        .carouselText {
            display: flex;
            width: 396px;
            height: 100%;
            flex-direction: column;
            justify-content: center;
            gap: 62px;
            flex-shrink: 0;
        }

        .title {
            font-size: 14px;
        }

        .pharse {
            font-size: 22px;
        }

        .author {
            font-size: 14px;
        }

        img {
            width: 100%; /* 이미지 크기 유동적으로 조정 */
            height: auto; /* 비율 유지 */
        }
    }
    
    
`;
const dotCss = css`
    width: 30px;
    height: 4px;
`;
